var React = require('react');

function Voume0 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40 4L20 20H4V44H20L40 60V4Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Voume0.defaultProps = {"width":"44","height":"64","viewBox":"0 0 44 64","fill":"none"};

module.exports = Voume0;

Voume0.default = Voume0;
